export const SNIPPET_RECONCILIATION_TYPE = {
	REMOVE: 'remove',
	UPSERT: 'upsert',
} as const;

export type SnippetReconciliationType =
	(typeof SNIPPET_RECONCILIATION_TYPE)[keyof typeof SNIPPET_RECONCILIATION_TYPE];
